import axios from "axios";
var CryptoJS = require("crypto-js");

// Accès aux données du module « SAV Web » (suivi des appels / tickets).
// Base : https://<VUE_APP_MAIN_URL>/api/sav-web/v1/<action>
// Chaque appel chiffre le payload (AES), déchiffre la réponse, et renvoie
// { code: -1 } en cas d'erreur réseau (jamais de crash de l'interface).
class DataApi {
    constructor() {
        this.URL = "https://" + process.env.VUE_APP_MAIN_URL + "/api/sav-web";
        this.cryptageKey = "2687da56-4181-48a6-bec4-c526727423f8"
    }

    encrypt(datas) {
        return { data: CryptoJS.AES.encrypt(JSON.stringify(datas), this.cryptageKey).toString() }
    }

    decrypt(data) {
        var bytes = CryptoJS.AES.decrypt(data, this.cryptageKey);
        var originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return originalData
    }

    post(action, datas, callback) {
        axios.post(this.URL + '/v1/' + action, this.encrypt(datas || {}), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            let out;
            try { out = this.decrypt(res.data); } catch (e) { out = { code: -1 }; }
            callback(out);
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Tickets les plus récemment modifiés ({ limit }) ou seulement ceux modifiés
    // depuis un horodatage FileMaker ({ modifiedSince }) pour l'actualisation.
    get_tickets(params, callback) {
        this.post('get_tickets', params, callback);
    }

    // Fil d'échanges d'un ticket (clé primaire).
    get_echanges(id, callback) {
        this.post('get_echanges', { id }, callback);
    }

    // Liste des clients (layout « Clients »), mise en cache côté serveur.
    get_clients(force, callback) {
        this.post('get_clients', { force: !!force }, callback);
    }

    // Nouveau ticket → { recordId }.
    create_ticket(ticket, callback) {
        this.post('create_ticket', { ticket }, callback);
    }

    // Modification d'un ticket : { recordId, id, changes, auteur, events }.
    update_ticket(payload, callback) {
        this.post('update_ticket', payload, callback);
    }

    // Nouvel échange : { id, recordId, type, message, auteur }.
    add_echange(payload, callback) {
        this.post('add_echange', payload, callback);
    }
}

export default new DataApi()
